'use strict';

const customerId = require('./lib/customer-id');
const shipmentId = require('./lib/shipment-id');

module.exports = { ...customerId, ...shipmentId };
